import { Descriptions, Popover } from 'antd';
import React from "react";

export const EAssessmentType = {
  不考核: "0",
  考核: "1",
};

export const RevertEAssessmentType = {
  [EAssessmentType.不考核]: "不考核",
  [EAssessmentType.考核]: "考核",
};

export const EYearToWord = {
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
};
/**
 * 继续率考核政策
 * @param props { cycles: ICyclesItem[]; }
 */
const ContinueRateInfoPolicyList = (props) => {
    const getCap = (num)=> {
        const capArr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        let c = '';
        num = '' + num; //隐式转换为字符串
        for(let i = 0;i < num.length ; i++){
          c += capArr[parseInt(num.charAt(i))]
        }
        return c;
      }
  return (
    <div>
      {props.cycles &&
        props.cycles.length > 0 &&
        props.cycles.map((item,index) => {
          return (
            String(item.assessmentFlag) === EAssessmentType.考核 && <React.Fragment key={index}>
              <div className={"rate-list"}>
                {`第${EYearToWord[item.year]}年`}
                {/* <span className={"rate-list-content"}>
                  {RevertEAssessmentType[item.assessmentFlag]}
                </span> */}
              </div>
              {String(item.assessmentFlag) === EAssessmentType.考核 && (
                <div className={"rate-list-policy"}>
                    {item.standardAssessFlag===1&&<div>
                        <div className='rate-header'>
                           {props.paymentMethod ===2 ? '续期推广费 = 当前实缴保费x续期推广费费率x系数':'我司向贵司支付续期推广费=当期实缴保费x续期推广费费率x系数'}
                        </div>
                        <div style={{paddingLeft:'16px'}}>
                            <div className='rules-list'>
                                {
                                   props.configFlag !== 1 && item.assessmentPolicy && <Descriptions title="">
                                        <Descriptions.Item label="继续率考核政策">
                                            <span style={{'white-space': 'pre-line'}}>
                                                {item.assessmentPolicy}
                                            </span>
                                        </Descriptions.Item>
                                    </Descriptions>
                                }
                                {
                                    item?.rules && <div className="tableHead">
                                        <div className="headLeft">{ props.paymentMethod !==2 ? '继续率梯度' : '继续率（%）'}</div>
                                        <div className = 'headRight'>系数</div>
                                    </div>
                                }

                                <div  className="tableBody">
                                    {
                                        item?.rules && item?.rules.map(record=>{
                                            return  <div className="bodyItem" key={record}>
                                                <div className="bodyLeft">
                                                    <div>{record.endPercentageg ? (<span>
                                                        {record.startPercentage}%{' '}
                                                        {0 === record.startFlag ? '<' : '≤'}{' '}{item.cycle}{' '}
                                                        {0 === record.endFlag  ? '<'  : '≤'}{' '}
                                                        {record.endPercentageg}%
                                                    </span>) : (
                                                        <span>-</span>
                                                    )}</div>
                                                </div>
                                                <div className = 'bodyRight'><span>{record.calculateType===3?'0%':record.calculateType===1?'100%':record.calculateRate+'%'}</span></div>
                                            </div>
                                        })
                                    }
                                </div>


                            </div>
                        {/* <div className="rules-list">
                                <div className="header">
                                    条款取值范围
                                </div>
                                <div className="content">
                                    {item.feeClauseRange===1?'同继续率计入条款':'所有条款'}
                                    <span className="des">注：当继续率政策为全额发放或全额扣除时无效</span>
                                </div>
                        </div> */}
                        </div>
                    </div>}
                    {item.compensationRule&&item.compensationAssessFlag!==0&&<div>
                        {/* <div className='rate-header'>
                            继续率补偿政策
                        </div> */}
                        <div style={{paddingLeft:'16px'}}>
                            {item.compensationAssessFlag===1&&<div className="rules-list">
                                    <div className="header">
                                        {/* 退保率处罚金 */}
                                        退保率补偿金
                                    </div>
                                    <div className="content">
                                        {props.paymentMethod !==2 && <p>当贵司推广保单的实际退保率大于系统约定退保率标准时，贵司应向我司支付退保率补偿金，计算规则如下：</p>}
                                        <div style={{'display': 'flex','alignItems': 'center'}}>{`首次：当前月实际退保率>${item.compensationRule.surrenderRateLimit}%`}
                                       <Popover placement="bottomLeft"
                                            title=""
                                            content={'系统约定的退保率'}
                                            arrowPointAtCenter
                                        >
                                        <div className='mark' style={{'color': '#FF7736'}}>?</div></Popover>,退保率补偿金=（当前月实际退保率-{item.compensationRule.surrenderRateLimit}%<Popover placement="bottomLeft"
                                            title=""
                                            content={'系统约定的退保率'}
                                            arrowPointAtCenter
                                        >
                                        <div className='mark' style={{'color': '#FF7736'}}>?</div></Popover>）x{item.compensationRule.surrenderCalculationBase===1?'首年推广费':item.compensationRule.surrenderCalculationBase===2?'首年总保费':item.compensationRule.surrenderCalculationBase===3?'首年计入继续率条款保费':'应续总保费'}</div>
                                       <p style={{'display': 'flex','alignItems': 'center'}}>后续月份：退保率补偿金=（当前月实际退保率-上-月退保率）x {item.compensationRule.surrenderCalculationBase===1?'首年推广费':item.compensationRule.surrenderCalculationBase===2?'首年总保费':item.compensationRule.surrenderCalculationBase===3?'首年计入继续率条款保费':'应续总保费'}</p>
                                    </div>
                            </div>}
                            {(item.compensationAssessFlag===1||item.compensationAssessFlag===2)&&<div className="rules-list">
                                    <div className="header">
                                        继续率补偿金
                                    </div>
                                    <div className="content">
                                        {props.paymentMethod !==2 && <p>当贵司实际完成保单的继续率小于系统约定继续率标准时，贵司应向我司支付继续率补偿金，计算规则如下：</p>}
                                        <div style={{'display': 'flex','alignItems': 'center'}}>{`当${item.cycle}<${item.compensationRule.continueRateLimit}%`}<Popover placement="bottomLeft"
                                            title=""
                                            content={'系统约定的继续率'}
                                            arrowPointAtCenter
                                        >
                                        <div className='mark' style={{'color': '#FF7736'}}>?</div></Popover>时，继续率补偿金=（{item.compensationRule.continueRateLimit}%<Popover placement="bottomLeft"
                                            title=""
                                            content={'系统约定的继续率'}
                                            arrowPointAtCenter
                                        >
                                        <div className='mark' style={{'color': '#FF7736'}}>?</div></Popover>-{item.cycle}）x{item.compensationRule.continueCalculationBase===1?'首年推广费':item.compensationRule.continueCalculationBase===2?'首年总保费':item.compensationRule.continueCalculationBase===3?'首年计入继续率条款保费':'应续总保费'}</div>
                                    </div>
                            </div>}
                        </div>
                    </div>}
                    { !!item.otherRuleDesc && <div className='rate-header'>其他规则说明</div>}
                    { !!item.otherRuleDesc && <div className="content" style={{paddingLeft:'16px'}}>
                        {item.otherRuleDesc}
                    </div>}
                  {/* <span>继续率考核政策：</span>
                  <span className={"rate-policy-content"}>
                    {item.assessmentPolicy || ""}
                  </span> */}
                </div>
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};
export default ContinueRateInfoPolicyList;
